import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function usePMTaskSplitSearchEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.PMTaskSplitSearch, false);

  return Boolean(isEnabled);
}
